import React from 'react';
import { Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const BAFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-12 border-t-4 border-blue-600">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* About */}
            <div>
              <h3 className="text-2xl font-bold mb-4">Nisha Bharadwaj</h3>
              <p className="text-gray-300 mb-4">
                IT Systems Business Analyst · IAM & Compliance · Maryland, US
              </p>
              <p className="text-sm text-gray-400">
                All work samples sanitized · Company names replaced · All metrics are real
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Portfolio Sections</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#work" className="text-gray-300 hover:text-pink-300 transition-colors">
                    Work Samples
                  </a>
                </li>
                <li>
                  <a href="#flow" className="text-gray-300 hover:text-pink-300 transition-colors">
                    Process Flow
                  </a>
                </li>
                <li>
                  <a href="#dashboard" className="text-gray-300 hover:text-pink-300 transition-colors">
                    Dashboard
                  </a>
                </li>
                <li>
                  <a href="#stories" className="text-gray-300 hover:text-pink-300 transition-colors">
                    STAR Stories
                  </a>
                </li>
                <li>
                  <a href="#skills" className="text-gray-300 hover:text-pink-300 transition-colors">
                    Skills
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
              <ul className="space-y-3">
                <li>
                  <a href="mailto:udaynisha6@gmail.com" className="flex items-center gap-2 text-gray-300 hover:text-pink-300 transition-colors">
                    <Mail size={18} />
                    <span className="text-sm">udaynisha6@gmail.com</span>
                  </a>
                </li>
                <li>
                  <a href="tel:+14142176004" className="flex items-center gap-2 text-gray-300 hover:text-pink-300 transition-colors">
                    <Phone size={18} />
                    <span className="text-sm">+1 (414) 217-6004</span>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/nisha-bharadwaj-cspo-81378318b/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-300 hover:text-pink-300 transition-colors">
                    <Linkedin size={18} />
                    <span className="text-sm">LinkedIn Profile</span>
                  </a>
                </li>
                <li>
                  <div className="flex items-center gap-2 text-gray-300">
                    <MapPin size={18} />
                    <span className="text-sm">Maryland, United States</span>
                  </div>
                </li>
              </ul>
              <div className="mt-4">
                <span className="inline-block bg-green-500/20 border border-green-400 text-green-300 text-xs px-3 py-1 rounded-full">
                  H1B transfer ready
                </span>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Nisha Bharadwaj. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BAFooter;